export default __webpack_public_path__ + "static/media/openXMLIcon_disabled.01ca41c4.svg";